import React from "react";
import CountrySearchSelect from "./CountrySearchSelect";
import { countries } from "../../data/countries";

const AutoTab = ({
  count,
  onCountChange,
  gender,
  onGenderChange,
  country,
  onCountryChange,
  onGenerate,
  loading,
  lastResult = [],
}) => (
  <div className="mb-6">
    <p className="text-sm text-gray-600 mb-2">
      Enter the number of users to create. Optionally select gender and/or country; otherwise random.
    </p>
    <div className="flex flex-wrap items-end gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Number of users</label>
        <input
          type="number"
          min={1}
          max={100}
          value={count}
          onChange={(e) => onCountChange(e.target.value)}
          className="w-24 rounded-lg border border-gray-300 px-3 py-2 text-sm"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
        <select
          value={gender}
          onChange={(e) => onGenderChange(e.target.value)}
          className="rounded-lg border border-gray-300 px-3 py-2 text-sm min-w-[120px]"
        >
          <option value="">Any (random)</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div className="relative flex-1 min-w-[200px] max-w-md">
        <CountrySearchSelect
          countries={countries}
          value={country}
          onChange={onCountryChange}
          placeholder="Search and select country (optional)"
          label="Country"
        />
      </div>
      <button
        type="button"
        onClick={onGenerate}
        disabled={loading}
        className="rounded-lg border border-red-500 bg-red-500 px-4 py-2 text-sm font-semibold text-white hover:bg-red-600 disabled:opacity-50"
      >
        {loading ? "Creating…" : "Generate users"}
      </button>
    </div>
    {lastResult.length > 0 && (
      <div className="mt-4">
        <p className="text-sm font-medium text-gray-700 mb-2">Last created (email / password):</p>
        <div className="overflow-x-auto rounded-lg border border-gray-200">
          <table className="min-w-full text-xs md:text-sm">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-3 py-2 text-left font-semibold text-gray-600">#</th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600">Email</th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600">Password</th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600">User ID</th>
              </tr>
            </thead>
            <tbody>
              {lastResult.map((u, idx) => (
                <tr key={u.userId} className="border-t border-gray-100">
                  <td className="px-3 py-2">{idx + 1}</td>
                  <td className="px-3 py-2 font-mono text-gray-900">{u.email}</td>
                  <td className="px-3 py-2 font-mono text-gray-700">{u.password}</td>
                  <td className="px-3 py-2">{u.userId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
);

export default AutoTab;
